import { forwardRef, type Ref, type SVGProps } from "react";
const IconMLSFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m8.7 4-3-2a.5.5 0 0 0-.5 0l-3 2a.5.5 0 0 0-.2.5v5a.5.5 0 0 0 .5.5h2V6.5h2V10h2a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.3-.5m0 10-3-2a.5.5 0 0 0-.5 0l-3 2a.5.5 0 0 0-.3.5v5a.5.5 0 0 0 .6.5h2v-3.5h2V20h2a.5.5 0 0 0 .4-.5v-5a.5.5 0 0 0-.2-.4zm0 10-3-2a.5.5 0 0 0-.5 0l-3 2a.5.5 0 0 0-.3.5v5a.5.5 0 0 0 .6.5h2v-3.5h2V30h2a.5.5 0 0 0 .4-.5v-5a.5.5 0 0 0-.2-.4z" />
    <rect width={17} height={4} x={13} y={5} rx={2} />
    <rect width={17} height={4} x={13} y={14} rx={2} />
    <rect width={17} height={4} x={13} y={23} rx={2} />
  </svg>
);
const ForwardRef = forwardRef(IconMLSFilledSVG);
ForwardRef.displayName = "IconMLSFilled";
export { ForwardRef as IconMLSFilled };
